// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import subscribe from "@insite/client-framework/Store/CommonHandlers/Subscribe";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField"; // Starter Custom Code
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as cssLinter from "css";
import parse from "html-react-parser";
// import React, { useContext, useState } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden/VisuallyHidden";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import { widgetWrapperStyles } from "@store/Library/Components/Toolkit/WidgetWrapper";
import TextField, { TextFieldPresentationProps } from "@store/MobiusOverrides/TextField/TextField";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import constants from "@toolkit/Framework/Common/GoogleAnalytics/constants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useContext, useRef, useState } from "react";
/* Starter Custom Code - End */

const enum fields {
    label = "label",
    title = "title",
    description = "description",
    placeholder = "placeholder",
    disclaimer = "disclaimer",
    alignment = "alignment",
    customCSS = "customCSS",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.label]: string;
        [fields.description]: string;
        [fields.placeholder]: string;
        [fields.disclaimer]: string;
        [fields.alignment]: string;
        [fields.customCSS]: string;
    };
}

const mapDispatchToProps = {
    subscribe,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface SubscribeStyles {
    mainGridContainer?: GridContainerProps; // Starter Custom Code
    titleGridItem?: GridItemProps;
    titleLabel?: TypographyPresentationProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyPresentationProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    emailButton?: ButtonPresentationProps;
    disclaimerGridItem?: GridItemProps;
    disclaimerText?: InjectableCss; // Starter Custom Code
    // Starter Custom Code
    wrapper?: InjectableCss;
}

export const subscribeStyles: SubscribeStyles = {
    titleLabel: {
        variant: "h6",
    },
    descriptionText: {
        css: css`
            display: block;
            margin-bottom: ${pxToRem(8)};
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    emailTextField: {
        ...buttonGetFieldIconProps(ArrowForward),
    },
    disclaimerText: {
        css: css`
            margin-top: ${pxToRem(5)};
            font-size: ${x => x.theme.design.typography.size.tiny};
        `,
    },
    wrapper: {
        css: css`
            ${widgetWrapperStyles.css}
            max-width: ${pxToRem(445)};
        `,
    },
};

/* Starter Custom Code - Start */
const defaultCustomCss = `.title{
}

.description-text{
}

.email-text-field{
}

.email-button{
}

.disclaimer-text{
}`;
/* Starter Custom Code - End */

export const CmsSubscribe = ({ fields, subscribe, id }: Props) => {
    const emailRequiredFieldMessage = siteMessage("EmailSubscription_EmailIsRequiredErrorMessage");
    const emailFieldMessage = siteMessage("EmailSubscription_EmailIsInvalidErrorMessage");

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const toasterContext = useContext(ToasterContext);

    const styles = useMergeStyles("subscribe", subscribeStyles);

    /* Starter Custom Code - Start */
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [canTrackFormStart, setCanTrackFormStart] = useState(true);
    const trackFormStart = ga.use.trackFormStart({ form_name: constants.subscribeNewsletter.form_name });
    const trackFormSubmit = ga.use.trackFormSubmit({ form_name: constants.subscribeNewsletter.form_name });
    const emailFieldRef = useRef<HTMLInputElement>(null);
    /* Starter Custom Code - End */

    const onSubscribeClick = () => {
        setIsSubmitted(true);
        if (!checkEmail(email)) {
            return;
        }

        subscribe({
            email,
            onSuccess: () => {
                toasterContext.addToast({ body: siteMessage("Email_Subscribe_Success"), messageType: "success" });
                /* Starter Custom Code - Start */
                trackFormSubmit();
                setCanTrackFormStart(true);
                setIsSubmitting(false);
                setEmail("");
                /* Starter Custom Code - End */
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.();
                }
            },
        });
    };

    const emailChangeHandler = (email: string) => {
        checkEmail(email);
        setEmail(email);

        /* Starter Custom Code - Start */
        if (canTrackFormStart) {
            trackFormStart();
            setCanTrackFormStart(false);
        }
        /* Starter Custom Code - End */
    };

    const checkEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : validateEmail(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        emailFieldRef.current?.focus(); // Starter Custom Code
        return !errorMessage;
    };

    // Starter Removed - gridItemCss

    const customCssWrapper = {
        css: css`
            ${styles.wrapper?.css /* Starter Custom Code */}
            ${fields.customCSS}
        `,
    };

    /* Starter Custom Code - Start */
    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSubscribeClick();
    };

    return (
        <StyledWrapper {...customCssWrapper} as="form" onSubmit={onSubmit} noValidate>
            {fields.title ? (
                <Typography className="title" {...styles.titleLabel}>
                    {fields.title}
                </Typography>
            ) : null}
            {fields.description ? (
                <Typography className="description-text" {...styles.descriptionText} forwardAs="label" htmlFor={id}>
                    {fields.description}
                </Typography>
            ) : null}
            <TextField
                className="email-text-field"
                {...styles.emailTextField}
                id={id}
                placeholder={fields.placeholder}
                value={email}
                onChange={e => emailChangeHandler(e.currentTarget.value)}
                error={isSubmitted && emailError}
                labelId={id}
                clickableText={fields.label}
                iconClickableProps={{
                    ...styles.emailTextField?.iconClickableProps,
                    onClick: () => {},
                    className: "email-button",
                    type: "submit",
                    disabled: isSubmitting,
                }}
                readOnly={isSubmitting}
                isLoading={isSubmitting}
                // Starter Custom Code
                required
                ref={emailFieldRef}
            />
            {emailError ? <VisuallyHidden role="alert">{emailError}</VisuallyHidden> : null}
            {fields.disclaimer ? (
                <StyledWrapper className="disclaimer-text" {...styles.disclaimerText}>
                    {parse(fields.disclaimer, parserOptions)}
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
    /* Starter Custom Code - End */
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(CmsSubscribe),
    definition: {
        group: "Basic",
        icon: "bell",
        fieldDefinitions: [
            {
                name: fields.alignment,
                displayName: "Layout",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "flex-start" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "flex-end" },
                ],
                defaultValue: "center",
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "", // Starter Custom Code
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "TextField", // Starter Custom Code
                defaultValue: "Keep up-to-date on product news and the latest offers.", // Starter Custom Code
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.placeholder,
                displayName: "Placeholder Text",
                editorTemplate: "TextField",
                defaultValue: "Enter email address",
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.disclaimer,
                displayName: "Disclaimer",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.label,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "Subscribe",
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
